module.exports = __webpack_public_path__ + "img/polar-logo.05b794d0.png";